import { cleanName, PLAYER_ID } from '../net/protocol';
import { loadSetting, saveSetting } from './storage';

/**
 * Who's playing, for the leaderboard: a random id this browser keeps (so a
 * better lap replaces your old one) and the name you race under.
 */
export interface Player {
  id: string;
  /** '' until you first put a lap on the board. */
  name: string;
}

/** Whether this browser has a player already (it has opened the game before). Ask before loadPlayer makes one. */
export function hasPlayer(): boolean {
  const stored = loadSetting<Partial<Player>>('player', {});
  return typeof stored.id === 'string' && PLAYER_ID.test(stored.id);
}

export function loadPlayer(): Player {
  const stored = loadSetting<Partial<Player>>('player', {});
  const id = typeof stored.id === 'string' && PLAYER_ID.test(stored.id) ? stored.id : newPlayerId();
  const player: Player = { id, name: typeof stored.name === 'string' ? cleanName(stored.name) : '' };
  if (id !== stored.id) saveSetting('player', player);
  return player;
}

export function savePlayer(p: Player): void {
  saveSetting('player', p);
}

/**
 * The name a player's first clean lap goes up under when they haven't given one: "Pilota 48", from their id,
 * so the same every day (until they pick their own).
 */
export function madeUpName(playerId: string): string {
  const n = parseInt(playerId.replace(/-/g, '').slice(0, 8), 16);
  return `Pilota ${10 + ((Number.isFinite(n) ? n : 0) % 90)}`;
}

/** A v4 UUID. crypto.randomUUID needs a secure context; getRandomValues works on plain http too (a phone on the LAN). */
export function newPlayerId(): string {
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
